(() => {
  if (window.cycoSmartDrawerLoaded) return;
  window.cycoSmartDrawerLoaded = true;
  const script = document.querySelector('[data-cyco-drawer-script]');
  const previewId = script?.dataset.previewThemeId;
  const root = window.Shopify?.routes?.root || '/';
  const sectionId = 'cyco-drawer-smart';
  let timer, lastKey = '', request = 0, busy = false, latestSource;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const drawer = () => document.querySelector('.Vtl-CartDrawer[aria-hidden="false"]');
  const key = node => JSON.stringify([
    [...node.querySelectorAll('.Vtl-CartDrawerProduct')].map(product => [
      product.querySelector('a')?.href,
      product.querySelector('.Vtl-CartDrawerProduct__Details-Top-Variants')?.textContent,
      product.querySelector('.Vtl-CartDrawerProduct__Details-Bottom-Prices')?.textContent
    ]),
    [...node.querySelectorAll('.Vtl-CartDrawerProducts input')].map(input => input.value),
    node.querySelector('.Vtl-CartDrawerCheckout')?.textContent
  ]);
  const endpoint = () => {
    const url = new URL(`${root}cart`, location.origin);
    url.searchParams.set('sections', sectionId);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return url;
  };
  const read = async () => {
    const response = await fetch(endpoint(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('refresh');
    const data = await response.json();
    const page = parse(data[sectionId] || '');
    const source = page.querySelector('[data-cyco-drawer-data]');
    if (!source) throw new Error('refresh');
    return source;
  };
  const choose = source => {
    for (const kind of ['gift_box', 'small_box', 'clasp', 'velorosa', 'watch_bracelet', 'chain_necklace', 'rider_keyring', 'easy_extra']) {
      const card = source.querySelector(`[data-cyco-kind="${kind}"]`);
      if (card) return card;
    }
    return null;
  };
  const message = (node, text) => {
    const status = node?.querySelector('[data-cyco-drawer-status]');
    if (status) { status.textContent = text; status.hidden = !text; }
  };
  const labelProducts = (node, source) => {
    const products = node.querySelector('.Vtl-CartDrawerProducts');
    if (!products) return;
    const exclusions = source.querySelector('[data-cyco-drawer-excluded]')?.content;
    products.querySelectorAll('.Vtl-CartDrawerProduct').forEach(product => {
      const anchor = product.querySelector('a[href*="/products/"]');
      const handle = anchor ? new URL(anchor.href).pathname.split('/products/')[1]?.split('/')[0] : '';
      const excluded = [...(exclusions?.querySelectorAll('[data-product-handle]') || [])].find(item => item.dataset.productHandle === handle);
      const old = product.querySelector('[data-cyco-item-excluded]');
      if (excluded && !old) {
        const label = document.createElement('p');
        label.dataset.cycoItemExcluded = '';
        label.textContent = excluded.textContent;
        product.querySelector('.Vtl-CartDrawerProduct__Details-Top')?.append(label);
      } else if (!excluded && old) old.remove();
    });
  };
  const render = (node, source) => {
    const products = node.querySelector('.Vtl-CartDrawerProducts');
    if (!products) return;
    latestSource = source;
    labelProducts(node, source);
    let progress = node.querySelector('[data-cyco-drawer-offer]');
    if (!progress) {
      progress = document.createElement('div');
      progress.dataset.cycoDrawerOffer = '';
      products.before(progress);
    }
    progress.innerHTML = source.querySelector('[data-cyco-drawer-progress]').innerHTML;
    const code = progress.querySelector('.cyco-cart-offer__code');
    if (code) {
      if (code.getAttribute('href')?.includes('/discount/')) {
        const hint = document.createElement('span');
        hint.className = 'cyco-drawer-code';
        hint.textContent = code.textContent;
        code.replaceWith(hint);
      } else code.remove();
    }
    let slot = node.querySelector('[data-cyco-drawer-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.dataset.cycoDrawerSlot = '';
      products.after(slot);
    }
    const oldFocus = slot.contains(document.activeElement);
    slot.replaceChildren();
    const card = choose(source);
    if (card) {
      const copy = card.cloneNode(true);
      copy.querySelectorAll('[data-cyco-add]').forEach(button => {
        button.dataset.cycoDrawerAdd = button.dataset.cycoAdd;
        button.removeAttribute('data-cyco-add');
      });
      copy.querySelectorAll('[data-cyco-select]').forEach(select => {
        select.dataset.cycoDrawerSelect = '';
        select.removeAttribute('data-cyco-select');
      });
      slot.append(copy);
    }
    const status = document.createElement('p');
    status.dataset.cycoDrawerStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    slot.append(status);
    slot.dataset.adding = source.dataset.adding;
    slot.dataset.error = source.dataset.error;
    slot.dataset.success = source.dataset.success;
    slot.dataset.stale = source.dataset.stale;
    if (oldFocus) {
      slot.tabIndex = -1;
      slot.focus({ preventScroll: true });
    }
    node.classList.add('cyco-drawer-enhanced');
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const node = drawer();
      if (!node || busy) return;
      if (node.querySelector('.Vtl-CartDrawerProducts[aria-busy="true"]')) {
        lastKey = '';
        node.querySelector('[data-cyco-drawer-slot]')?.setAttribute('hidden', '');
        node.querySelector('[data-cyco-drawer-offer]')?.setAttribute('hidden', '');
        return;
      }
      const currentKey = key(node);
      if (currentKey === lastKey && node.querySelector('[data-cyco-drawer-slot]')) {
        if (latestSource) labelProducts(node, latestSource);
        return;
      }
      const id = ++request;
      node.querySelector('[data-cyco-drawer-slot]')?.setAttribute('hidden', '');
      node.querySelector('[data-cyco-drawer-offer]')?.setAttribute('hidden', '');
      try {
        const source = await read();
        if (id !== request || !node.isConnected || node !== drawer()) return;
        if (key(node) !== currentKey) { schedule(); return; }
        render(node, source);
        lastKey = currentKey;
        node.querySelector('[data-cyco-drawer-slot]')?.removeAttribute('hidden');
        node.querySelector('[data-cyco-drawer-offer]')?.removeAttribute('hidden');
      } catch {
        if (id === request) node.classList.remove('cyco-drawer-enhanced');
      }
    }, 160);
  };
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-cyco-drawer-select]');
    if (!select) return;
    const card = select.closest('[data-cyco-card]');
    const button = card.querySelector('[data-cyco-drawer-add]');
    const option = select.selectedOptions[0];
    if (!button || !option) return;
    button.dataset.cycoDrawerAdd = select.value;
    button.disabled = !select.value;
    const label = card.querySelector('.cyco-cart-card__variant');
    if (label) label.textContent = option.dataset.variantTitle || option.textContent;
    if (option.dataset.price) card.querySelector('.cyco-cart-card__price').textContent = option.dataset.price;
    if (option.dataset.image) {
      const image = card.querySelector('img');
      if (image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-cyco-drawer-add]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled || !button.dataset.cycoDrawerAdd) return;
    const node = button.closest('.Vtl-CartDrawer');
    if (node.querySelector('.Vtl-CartDrawerProducts[aria-busy="true"]')) return;
    const slot = button.closest('[data-cyco-drawer-slot]');
    const card = button.closest('[data-cyco-card]');
    const variant = button.dataset.cycoDrawerAdd;
    busy = true;
    ++request;
    const controls = [...node.querySelectorAll('button:not([aria-label="Close Cart Drawer"]), input, select')];
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    slot.setAttribute('aria-busy', 'true');
    message(node, slot.dataset.adding);
    let added = false;
    try {
      const source = await read();
      const fresh = choose(source);
      const valid = fresh && fresh.dataset.cycoProduct === card.dataset.cycoProduct &&
        fresh.dataset.cycoKind === card.dataset.cycoKind && fresh.dataset.cycoParentKey === card.dataset.cycoParentKey &&
        [...fresh.querySelectorAll('[data-cyco-add], option')].some(option => (option.dataset.cycoAdd || option.value) === variant);
      if (!valid) {
        render(node, source);
        message(node, slot.dataset.stale);
        return;
      }
      const mainId = document.querySelector('[data-section-type="cart"]')?.dataset.sectionId;
      const sections = mainId ? [sectionId, mainId] : [sectionId];
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variant), quantity: 1, properties: { _cyco_addon_rule: card.dataset.cycoKind, _cyco_addon_source: 'drawer' } }],
          sections, sections_url: `${root}cart${previewId ? `?preview_theme_id=${previewId}` : ''}`
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || slot.dataset.error);
      added = true;
      if (mainId && data.sections?.[mainId]) {
        const page = parse(data.sections[mainId]);
        const current = document.querySelector('[data-section-type="cart"]');
        for (const selector of ['.cart-items', '.subtotal-row', '[data-cyco-offer-slot]', '[data-cyco-extras-slot]', '.cart-finish']) {
          const old = current?.querySelector(selector), next = page.querySelector(selector);
          if (old && next) old.innerHTML = next.innerHTML;
        }
      }
      const after = parse(data.sections?.[sectionId] || '').querySelector('[data-cyco-drawer-data]') || await read();
      render(node, after);
      message(node, slot.dataset.success);
      document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
    } catch (error) {
      if (added) {
        slot.querySelector('[data-cyco-card]')?.remove();
        message(node, slot.dataset.success);
        document.dispatchEvent(new CustomEvent('vitals:cart-drawer:syncRequested'));
      } else message(node, error.message === 'refresh' ? slot.dataset.error : error.message);
    } finally {
      busy = false;
      controls.forEach((control, i) => { if (control.isConnected) control.disabled = disabled[i]; });
      slot.removeAttribute('aria-busy');
      lastKey = '';
      schedule();
    }
  });
  for (const type of ['vitals:cart-drawer:opened', 'vitals:CartUpdated', 'vitals:CartUpdateFinish', 'cyco:cart-addon-added']) {
    document.addEventListener(type, schedule);
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('[data-cyco-drawer-slot], [data-cyco-drawer-offer]'))) schedule();
  });
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-busy'] });
    schedule();
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
